import React from 'react';
import { Bars3Icon, BellIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';


const Header = ({ onMenuClick }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="header-left">
          <button type="button" className="header-menu-btn" onClick={onMenuClick} aria-label="Open sidebar">
            <Bars3Icon className="header-menu-icon" aria-hidden="true" />
          </button>
          <h1 className="header-title">School Management System</h1>
        </div>

        <div className="header-right">
          <button type="button" className="header-notification-btn" aria-label="View notifications">
            <BellIcon className="header-notification-icon" aria-hidden="true" />
          </button>

          <button type="button" className="header-logout-btn" onClick={handleLogout} aria-label="Logout">
            <ArrowRightOnRectangleIcon className="header-logout-icon" aria-hidden="true" />
          </button>

          <div className="header-user">
            <div className="header-user-avatar">
              {user?.username?.charAt(0).toUpperCase()}
            </div>
            <div className="header-user-info">
              <p className="header-user-name">{user?.username}</p>
              <p className="header-user-role">{user?.role}</p>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;